/** The admin home screen, including what the stock on the shelves is worth. */
const dashboard = {
  en: {
    title: "Dashboard overview",
    welcome: "Welcome back! Here's what's happening with your store.",
    loadFailed: "Failed to load dashboard",
    totalProducts: "Total products",
    totalCustomers: "Total customers",
    monthlyRevenue: "Monthly revenue",
    weekly: "Weekly: {amount}",
    pendingPreorders: "Pending pre-orders",
    topProducts: "🏆 Top selling products",
    viewAll: "View all →",
    columns: {
      product: "Product",
      category: "Category",
      price: "Price",
      sold: "Sold",
      revenue: "Revenue",
    },
    lowStock: "⚠️ Low stock alerts",
    manageStock: "Manage stock →",
    stock: "Stock: {count}",
    price: "Price: {amount}",
    stockValue: {
      title: "Inventory report by category",
      products: "Products",
      totalStock: "Total stock",
      value: "Value",
      valueBy: "Value stock at",
      where: "Which stock",
      locations: { shop: "Shop", warehouse: "Warehouse", both: "Both" },
      sellPrice: "Sell price",
      buyPrice: "Buy price",
      total: "Total",
      uncosted: "{count} product without a buy price is counted as 0",
      uncostedPlural: "{count} products without a buy price are counted as 0",
    },
  },

  fr: {
    title: "Vue d'ensemble",
    welcome: "Bon retour ! Voici ce qui se passe dans votre boutique.",
    loadFailed: "Impossible de charger le tableau de bord",
    totalProducts: "Produits",
    totalCustomers: "Clients",
    monthlyRevenue: "Revenu du mois",
    weekly: "Cette semaine : {amount}",
    pendingPreorders: "Précommandes en attente",
    topProducts: "🏆 Meilleures ventes",
    viewAll: "Tout voir →",
    columns: {
      product: "Produit",
      category: "Catégorie",
      price: "Prix",
      sold: "Vendus",
      revenue: "Revenu",
    },
    lowStock: "⚠️ Stocks bas",
    manageStock: "Gérer le stock →",
    stock: "Stock : {count}",
    price: "Prix : {amount}",
    stockValue: {
      title: "Inventaire par catégorie",
      products: "Produits",
      totalStock: "Stock total",
      value: "Valeur",
      valueBy: "Valoriser le stock au",
      where: "Quel stock",
      locations: { shop: "Boutique", warehouse: "Entrepôt", both: "Les deux" },
      sellPrice: "Prix de vente",
      buyPrice: "Prix d'achat",
      total: "Total",
      uncosted: "{count} produit sans prix d'achat est compté à 0",
      uncostedPlural: "{count} produits sans prix d'achat sont comptés à 0",
    },
  },

  ar: {
    title: "نظرة عامة",
    welcome: "مرحباً بعودتك! إليك ما يحدث في متجرك.",
    loadFailed: "تعذّر تحميل لوحة التحكم",
    totalProducts: "المنتجات",
    totalCustomers: "الزبائن",
    monthlyRevenue: "إيراد الشهر",
    weekly: "هذا الأسبوع: {amount}",
    pendingPreorders: "طلبات مسبقة قيد الانتظار",
    topProducts: "🏆 الأكثر مبيعاً",
    viewAll: "عرض الكل ←",
    columns: {
      product: "المنتج",
      category: "الفئة",
      price: "السعر",
      sold: "المباع",
      revenue: "الإيراد",
    },
    lowStock: "⚠️ تنبيهات انخفاض المخزون",
    manageStock: "إدارة المخزون ←",
    stock: "المخزون: {count}",
    price: "السعر: {amount}",
    stockValue: {
      title: "تقرير المخزون حسب الفئة",
      products: "المنتجات",
      totalStock: "إجمالي المخزون",
      value: "القيمة",
      valueBy: "تقييم المخزون بـ",
      where: "أي مخزون",
      locations: { shop: "المتجر", warehouse: "المخزن", both: "الاثنان" },
      sellPrice: "سعر البيع",
      buyPrice: "سعر الشراء",
      total: "الإجمالي",
      uncosted: "{count} منتج بلا سعر شراء يُحتسب بصفر",
      uncostedPlural: "{count} منتجات بلا سعر شراء تُحتسب بصفر",
    },
  },
};

export default dashboard;
